import { i as s } from "../../_virtual/isBuffer.js";
import v from "./_root.js";
import B from "./stubFalse.js";
(function(r, e) {
  var a = v, i = B, f = e && !e.nodeType && e, o = f && !0 && r && !r.nodeType && r, u = o && o.exports === f, t = u ? a.Buffer : void 0, n = t ? t.isBuffer : void 0, p = n || i;
  r.exports = p;
})(s, s.exports);
//# sourceMappingURL=isBuffer.js.map
